import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ActionType } from '../models/action-type';
import { Config } from '../config/env.config';


@Injectable({
  providedIn: 'root'
})
export class ActionTypeDataService {
  constructor(private httpClient: HttpClient) { }
  // PUBLIC METHODS
  // NOTE: Changing all Configuration.groupApiURL/whatever to Config.apiUrl/actgroup/whatever.
  // POSSIBLE BREAKING CHANGE.

  
  public getAllActionType = () => {
    return this.httpClient.get<ActionType[]>(`${Config.apiUrl}/ActActionType/getAllactiontype`); // Configuration.groupApiURL}/getallgroups
  }
 
  public getSpecificActionTypeById(id): Observable<any> {
    return this.httpClient.get<ActionType>(`${Config.apiUrl}/ActActionType/getSpecificactiontypebyid/${id}`);
  }

  public addNewActionType(actionType): Observable<any> {
    return this.httpClient.post(`${Config.apiUrl}/ActActionType/addnewactiontype`, actionType as ActionType);
  }

  public updateActionType(actionType): Observable<any> {
    return this.httpClient.post(`${Config.apiUrl}/ActActionType/updateactiontype/${actionType.id}`, actionType as ActionType);
  }

  public deleteActionType(id): Observable<any> {
    return this.httpClient.delete(`${Config.apiUrl}/ActActionType/deleteactiontype/${id}`);
  }


}
